import { CustomerServiceOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import { Tooltip } from 'antd';
import React from 'react';

const CustomerService: React.FC = () => {
  const pathname = window.location.pathname;
  const match = pathname.match(/^\/(cdn-oper|saas-platform)/);
  const platform = match?.[1] || '';

  const supportPath = platform
    ? `/${platform}/workbench/support`
    : '/workbench/support';

  const handleClick = () => {
    history.push(supportPath);
  };

  return (
    <Tooltip title="帮助与支持">
      <span
        onClick={handleClick}
        style={{
          display: 'inline-flex',
          padding: '4px',
          fontSize: '18px',
          color: 'inherit',
          cursor: 'pointer',
        }}
      >
        <CustomerServiceOutlined />
      </span>
    </Tooltip>
  );
};

export default CustomerService;
